export enum ProgressEnum {
    Home = 0,
    Quiz = 1,
    LoadingPage = 13,
    EnergyPlan = 2,
    BroadbandPlan = 3,
    TvPlan = 4,
    MiniBox = 9,
    StreamingPlan = 5,
    SimCards = 6,
    WastePlan = 7,
    MarketingReview = 8,
    OrderSummary = 11,
    Status = 12,
    RenewalProperty = 14,
    RenewalContractEnd = 15,
    RenewalMeterReadings = 16,
    SecurityPlan  = 17,
    SecurityAddonPlan  = 18

}